// =============================================================================
// ui/shell/ShareButton.tsx — the header's Share control.
// -----------------------------------------------------------------------------
// ⚠ HIDDEN, NOT DISABLED, off the three shareable tabs — the same rule the
// camera follows and for the same reason: beta's `updateExportButtons()`
// (app/index.html:11801-11806) sets `display: none` on BOTH buttons, under its
// own comment "so they aren't dead buttons everywhere else".
// =============================================================================

import { useShare } from '../state/share';
import { Icon } from './Icon';

export function ShareButton() {
  const { source, begin, open } = useShare();

  // A tab opts in by registering a source; none has, so there is nothing here
  // to press.
  if (!source) return null;

  return (
    <button
      type="button"
      className="btn"
      onClick={begin}
      disabled={open}
      /* Icon only, as in beta — so the accessible name is the only name. */
      aria-label="Create a share link for this view"
      title={`Share ${source.title.toLowerCase()} as a read-only link`}
    >
      <Icon name="share" />
    </button>
  );
}
